module.exports = __webpack_public_path__ + "img/learner-quiz-Moose-Q2.b7c1993c.png";